import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function getAccessKey() {
  let k = localStorage.getItem("pb_access_key");
  if (!k) {
    k = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem("pb_access_key", k);
  }
  return k;
}

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("pb_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  config.headers["X-Access-Key"] = getAccessKey();
  return config;
});
